<!-- Título "Iniciar Sesión" -->
<!-- <h1
  class="text-md tracking-wider font-bold text-gray-800 mb-8 self-start fs-condensed pl-8"
>
  Iniciar Sesión
</h1> -->

<app-logo-header></app-logo-header>

<section class="w-full" aria-label="Opciones de inicio de sesión">
  <ng-container *ngTemplateOutlet="socialLoginSection"></ng-container>
  <ng-container *ngTemplateOutlet="dividerSection"></ng-container>
  <ng-container *ngTemplateOutlet="emailCTOText"></ng-container>
  <ng-container *ngTemplateOutlet="emailInputSection"></ng-container>
  <ng-container *ngTemplateOutlet="continueButtonSection"></ng-container>
</section>

<ng-template #socialLoginSection>
  <div class="my-6">
    <h2
      class="text-center mb-4 text-lg tracking-wider fs-condensed"
      aria-label="Opciones de inicio de sesión con redes sociales"
    >
      Ingresa con
    </h2>

    <div
      class="flex justify-around gap-2 items-center"
      role="group"
      aria-label="Botones de inicio de sesión social"
    >
      <!-- Botón Facebook -->
      <button
        type="button"
        class="w-12 h-12 rounded-full bg-white hover:bg-gray-100 flex items-center justify-center transition-colors"
        (click)="socialLogin(TIPO_PROVEEDOR_OAUTH.FACEBOOK)"
        [disabled]="isProcessingLogin()"
        aria-label="Iniciar sesión con Facebook"
        title="Iniciar sesión con Facebook"
      >
        <img
          src="/logos/third-party/facebook.svg"
          alt="Facebook"
          class="w-8 h-8"
          role="img"
          aria-hidden="false"
        />
      </button>
      <!-- Botón Google -->
      <button
        type="button"
        class="w-12 h-12 rounded-full bg-white hover:bg-gray-100 flex items-center justify-center transition-colors"
        (click)="socialLogin(TIPO_PROVEEDOR_OAUTH.GOOGLE)"
        [disabled]="isProcessingLogin()"
        aria-label="Iniciar sesión con Google"
        title="Iniciar sesión con Google"
      >
        <img
          src="/logos/third-party/google.svg"
          alt="Google"
          class="w-8 h-8"
          role="img"
          aria-hidden="false"
        />
      </button>
      <!-- Botón Apple -->
      <button
        type="button"
        class="w-12 h-12 rounded-full bg-white hover:bg-gray-100 flex items-center justify-center transition-colors"
        (click)="socialLogin(TIPO_PROVEEDOR_OAUTH.APPLE)"
        [disabled]="isProcessingLogin()"
        aria-label="Iniciar sesión con Apple"
        title="Iniciar sesión con Apple"
      >
        <img
          src="/logos/third-party/apple.svg"
          alt="Apple"
          class="w-8 h-8"
          role="img"
          aria-hidden="false"
        />
      </button>
      <!-- Botón Microsoft -->
      <button
        type="button"
        class="w-12 h-12 rounded-full bg-white hover:bg-gray-100 flex items-center justify-center transition-colors"
        (click)="socialLogin(TIPO_PROVEEDOR_OAUTH.MICROSOFT)"
        [disabled]="isProcessingLogin()"
        aria-label="Iniciar sesión con Microsoft"
        title="Iniciar sesión con Microsoft"
      >
        <img
          src="/logos/third-party/microsoft.svg"
          alt="Microsoft"
          class="w-8 h-8"
          role="img"
          aria-hidden="false"
        />
      </button>
    </div>
  </div>
</ng-template>

<ng-template #dividerSection>
  <div
    class="relative my-6"
    role="separator"
    aria-label="Separador entre opciones de inicio de sesión"
  >
    <div class="absolute inset-0 flex items-center justify-center">
      <div class="w-full border-t border-black"></div>
    </div>
    <div class="relative flex justify-center text-sm">
      <span class="px-2 bg-white" aria-hidden="true">ó</span>
    </div>
  </div>
</ng-template>

<ng-template #emailCTOText>
  <div class="mb-2">
    <h3
      class="text-base tracking-wider fs-condensed"
      aria-label="Opción de inicio de sesión con correo electrónico"
    >
      Inicia sesión o Regístrate
    </h3>
  </div>
</ng-template>

<ng-template #emailInputSection>
  <div class="mb-6">
    <label for="email-input" class="sr-only">Correo electrónico</label>
    <input
      [attr.aria-invalid]="emailError ? true : false"
      id="email-input"
      type="email"
      [(ngModel)]="email"
      placeholder="tu@email.com"
      [disabled]="isProcessingLogin()"
      [class]="
        `w-full px-4 py-3 border ${ emailError ? 'border-red-500' : 'border-gray-300' } rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent text-gray-700 placeholder-gray-400`
      "
      (keyup.enter)="continueWithEmail()"
      (input)="emailError = null"
      aria-describedby="email-error"
      autocomplete="email"
    />
    @if (emailError) {
    <p class="text-red-600 text-xs mt-2">{{ emailError.message }}</p>
    }
  </div>
</ng-template>

<ng-template #continueButtonSection>
  <button
    type="button"
    [disabled]="isProcessingLogin()"
    [class]="
    `w-full tracking-wider fs-condensed text-white py-3 rounded-lg font-medium text-lg transition-colors ${ isProcessingLogin() ? 'bg-gray-400 cursor-not-allowed flex items-center justify-center' : 'bg-allasRed hover:bg-allasRed-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2' }`
    "
    (click)="continueWithEmail()"
    [attr.aria-label]="
      isProcessingLogin()
        ? 'Validando información'
        : 'Continuar con el proceso de inicio de sesión'
    "
    [attr.title]="isProcessingLogin() ? 'Validando información' : 'Continuar'"
  >
    @if (isProcessingLogin() ) {
    <span class="flex items-center justify-center" aria-hidden="false">
      <app-loading-spinner size="sm"></app-loading-spinner>
      VALIDANDO...
    </span>
    } @else {
    <span aria-hidden="false">CONTINUAR</span>
    }
  </button>
  @if (error) {
  <div
    class="p-2.5 mt-4 bg-red-50 border border-red-200 rounded-lg"
    role="alert"
  >
    <p class="text-red-600 text-xs">{{ error.message }}</p>
  </div>
  }
</ng-template>
